import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=6702c719&scoped=true"
import script from "./DoughnutChart.vue?vue&type=script&lang=js"
export * from "./DoughnutChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6702c719",
  null
  
)

export default component.exports